import React, { useState } from "react";
import "./style.css";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { socialMediaConfig } from "../../../configs/configFooter";
import { Link } from "react-router-dom";

/*  This Component for displaying Footer 
*  Defining the data of social media from the config social media  file
 | khaled Mofeed | 29/10/2022 */

const socialMedia = socialMediaConfig;
function Footer() {
  const [readMore, setReadMore] = useState(false);

  return (
    <>
      <Row className="justify-content-center align-items-center  footer">
        <Col md={8} xl={6} className="text-center content-footer">
          <div className="title-div">
            <img src="img/logo.svg" alt="" id="id_logoFooter" />
          </div>
        </Col>
      </Row>
      <Row className="justify-content-center align-items-center ">
        <Col md={10} xl={10} className="text-center content-footer">
          <div className="text-dark row">
            <div
              className="col-md-4 text-center text-md-left"
              style={{ lineHeight: "3" }}
            >
              ©️ Copyright
              <Link
                to="https://Bullit.app/"
                target="_blank"
                rel="noreferrer"
                className="text-dark text-hover-primary mx-1"
              >
                Bullit.app
              </Link>
              2023. All rights reserved.
            </div>
            <div className="col-md-4 text-center">
              <ul className="social-media-ul">
                <li>
                  <a
                    href="https://www.linkedin.com/company/bullitapp/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/bullitapp/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fab fa-instagram"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.facebook.com/bullitapp"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fab fa-facebook-f"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://twitter.com/bullit_app"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fab fa-twitter"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://t.me/bullitapp"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fab fa-telegram-plane"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://medium.com/@bullit_app"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fab fa-medium-m"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://t.me/bullitapp_discussion"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fab fa-telegram-plane"></i>
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-md-4">
              <p
                className="mb-0 text-center text-md-right"
                style={{ lineHeight: "3" }}
              >
                For assistance, please contact{" "}
                <a href="mailto:general@bullit.app" className="text-primary">
                  general@bullit.app
                </a>
              </p>
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
}

export default Footer;
